import { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DyConsentBannerImage from '../../../../common/assets/images/dy-consent-banner-icon.png';
import Button from '../../../../common/widgets/Button';
import Dialog from '../../../../common/widgets/Dialog';
import { CustomerInfoContext } from '../../contexts/CustomerInfoContext';
import { OptInSourceTypes, OptInTypes } from '../../enums';
import { resources } from '../../resources/resources';
import { dynamicYieldService } from '../../services/dynamic-yield';
import { optInService } from '../../services/opt-in';

export const DyConsentDialog = (props: { closeDialog: () => void }) => {
  const { closeDialog } = props;
  const isProcessingRef = useRef(false);
  const { t: translate } = useTranslation();
  const { customerInfo, setCustomerInfo } = useContext(CustomerInfoContext);
  const [processingAction, setProcessingAction] = useState<
    'accept' | 'notNow' | null
  >(null);

  const onButtonClick = async (accepted: boolean) => {
    if (isProcessingRef.current) {
      return;
    }

    isProcessingRef.current = true;
    setProcessingAction(accepted ? 'accept' : 'notNow');

    try {
      await optInService.consent(
        OptInTypes.DynamicYield,
        accepted,
        OptInSourceTypes.HomePage,
      );
      if (accepted) {
        await dynamicYieldService.setDyId();

        setCustomerInfo({
          ...customerInfo,
          hasDynamicYieldConsent: true,
        });
      }
    } finally {
      setProcessingAction(null);
      closeDialog();
      isProcessingRef.current = false;
    }
  };

  return (
    <Dialog className="dialog-xl dialog-bottom dy-consent-dialog">
      <div className="dy-consent-dialog-container">
        <div className="dy-consent-dialog-title">
          <img src={DyConsentBannerImage} alt="" />
          <div>{translate(resources.recommendations.dialog.title)}</div>
        </div>
        <div
          className="dy-consent-dialog__text"
          dangerouslySetInnerHTML={{
            __html: translate(resources.recommendations.dialog.text),
          }}
        />
        <div className="dy-consent-dialog-buttons">
          <Button
            onClick={() => onButtonClick(true)}
            className="btn btn-solid dy-consent-dialog-accept"
            loading={processingAction === 'accept'}
            disabled={processingAction !== null}
          >
            <span className="btn-text">
              {translate(resources.recommendations.dialog.buttons.accept)}
            </span>
          </Button>
          <Button
            onClick={() => onButtonClick(false)}
            className="btn btn-outline dy-consent-dialog-not-now"
            loading={processingAction === 'notNow'}
            disabled={processingAction !== null}
          >
            <span className="btn-text">
              {translate(resources.recommendations.dialog.buttons.notNow)}
            </span>
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
